export { default } from './TableTabs';
export { default as TableTabPane } from './components/TableTabPane';
